import React from "react"
export function QuickApproval(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M4.466 2.903l.723.722-.574.572.578.576A7.482 7.482 0 0110 3.036c4.142 0 7.5 3.348 7.5 7.48 0 4.13-3.358 7.48-7.5 7.48-4.142 0-7.5-3.35-7.5-7.48 0-1.94.74-3.708 1.955-5.037l-.563-.56-.631.629-.723-.721 1.928-1.924zM10 4.056c-3.577 0-6.477 2.892-6.477 6.46 0 3.567 2.9 6.46 6.477 6.46 3.577 0 6.477-2.893 6.477-6.46 0-3.568-2.9-6.46-6.477-6.46zm3.71 3.33l.67.77L8.897 12.9a.512.512 0 01-.672-.002l-.05-.05-2.48-2.856.772-.668 2.146 2.471 5.096-4.408zm-.983-6.39v1.02H7.273V.996h5.454z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__quick-approval"
        />
      </g>
    </svg>
  )
}
